import styled from "styled-components";

import copyRegular from "../../icons/copy-regular.svg";
import checkSolid from "../../icons/check-solid.svg";
import trashCanRegular from "../../icons/trash-can-regular.svg";
import downloadIcon from "../../icons/arrow-down-solid.svg";

export const Container = styled.div`
  width: 450px;
  height: auto;
  color: white;
  display: flex;
  border-radius: 15px;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px;
  padding: 20px;
  background-color: #2a2a3c;
  position: relative;

  @media (max-width: 768px) {
    width: auto;
  }
`;

export const DraftAreaContainer = styled.div`
  padding-top: 10px;
  display: flex;
  height: 400px;
  width: 100%;
  overflow: auto;
  position: relative;
`;

export const CreatedAtContainer = styled.div`
  align-self: flex-end;
  color: rgb(194, 194, 194);
  font-size: 14px;
`;

export const LineNumbers = styled.div`
  user-select: none;
  pointer-events: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 20px;
  display: ${(props) => (props.isVisible ? "flex" : "none")};
`;

export const TypeContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  height: 20px;
  display: flex;
  justify-content: flex-end; /* Align content to the right */
  padding-right: 5px;
  color: #8f8f8f;
  font-size: 14px;
`;

export const EditAndDeleteButton = styled.button`
  background-color: transparent;
  color: white;
  border: 1px solid white;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    background-color: ${({ isDelete }) => (isDelete ? "red" : "transparent")};
  }
`;

export const CopyIcon = styled.img.attrs({
  src: copyRegular,
  alt: "Icon",
})`
  width: 15px;
  height: 15px;
  color: grey;
`;

export const CheckIcon = styled.img.attrs({
  src: checkSolid,
  alt: "Icon",
})`
  width: 15px;
  height: 15px;
  color: grey;
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TrashCanIcon = styled.img.attrs({
  src: trashCanRegular,
  alt: "Icon",
})`
  width: 15px;
  height: 15px;
  color: grey;
`;

export const DownloadIcon = styled.img.attrs({
  src: downloadIcon,
  alt: "Icon",
})`
  width: 15px;
  height: 15px;
  color: grey;
`;

export const EditAndDeleteButtonsContainer = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const ErrorText = styled.div`
  font-size: 13px;
  color: yellow;
  padding-top: 10px;
`;
